import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";

import NotFound from '../components/NotFound';
import AuthRoute from './Auth';
import PrivateRoute from './Private';

function RootRoute() {
    const { isAuthenticated } = useSelector((state) => state.auth);

    return (
        < >
            <Routes>               
                <Route path="/auth/*" element={<AuthRoute />} />
                <Route
                    path="/*"
                    element={
                        isAuthenticated ? (
                            <PrivateRoute />
                        ) : (
                            <Navigate to="/auth/login" replace />
                        )
                    }
                />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
}

export default RootRoute;
